// BSV CHANGES 
import { useState } from 'react';
import { useStyles } from './styles';
import { SearchBar } from '@app/components/widgets/searchBar';
import { Label } from '@app/components/elements/Label';
import { useDispatch, useSelector } from 'react-redux';
import { routeSelector } from '@app/router/redux';
import {
  getJfwRequest,
} from '@app/screens/module-specific-utilities/pages/dcr-jfw/redux';

export const DcrJfwNavbar = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [search, setSearch] = useState('');
  const [searchError, setSearchError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const navbarComponentHeading = useSelector(
    routeSelector.getNavbarComponentHeading(),
  );

  const handleSearchTextChange = (value: string) => {
    setSearch(value);

    if (!value || value.length >= 3) {
      setSearchError(false);
      dispatch(getJfwRequest({ searchText: value.trim() }));
    } else {
      setSearchError(true);
      setErrorMsg('Min 3 characters');
    }
  };

  const handleSearchPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (search.trim().length >= 3 || search.trim().length === 0) {
        setSearchError(false);
        dispatch(getJfwRequest({ searchText: search.trim() }));
      } else {
        setSearchError(true);
        setErrorMsg('Min 3 characters');
      }
    }
  };

  const handleClearClick = () => {
    setSearch('');
    setSearchError(false);
    setErrorMsg('');
    dispatch(getJfwRequest({}));
  };

  return (
    <div className={classes.container}>
      <div className={classes.flexSpaceBetween}>
        <Label
          title={navbarComponentHeading}
          variant="h6"
          testID={'superman_admin_navbar_heading'}
          textColor={'#322b7c'}
          fontWeight={'800'}
          hideToolTip
        />
      </div>
      <div className={classes.searchContainer}>
        <SearchBar
          searchText={search}
          handleChange={handleSearchTextChange}
          handleSearch={handleSearchPress}
          showError={searchError}
          placeHolder={'Search with Employee Code/Employee Name'}
          errorMessage={errorMsg}
          handleClear={handleClearClick}
        />
      </div>
    </div>
  );
};

